import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

declare var $: any;

@Component({
  selector: 'sa-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  moduleName : string ;
  logoName : string ;
  datai18n: any;
  developmentBy : string;
  constructor(private router: Router) {
  }

  ngOnInit() { 
      this.logoName='';
      if(JSON.parse(sessionStorage.getItem('module'))!==null){
          const module = JSON.parse(sessionStorage.getItem('module'));
      this.moduleName =  "LIT "// +module.moduleName;
      }
      else {
        this.moduleName="LIT";
      } 
      if(JSON.parse(sessionStorage.getItem('executingUnit'))!==null){
          const eu = JSON.parse(sessionStorage.getItem('executingUnit'));
          //console.log(eu);
          this.logoName= 'assets/img/lit/'+eu.abbreviation +'.png';  
          //console.log(this.logoName);
      }
      else {
          this.logoName='assets/img/lit/logo_lit.png'; 
      } 
      this.datai18n = JSON.parse(localStorage.getItem('datai18n'));
      this.developmentBy=this.datai18n['Header.label.development'];
  }


  searchMobileActive = false;

  toggleSearchMobile(){
    this.searchMobileActive = !this.searchMobileActive;

    $('body').toggleClass('search-mobile', this.searchMobileActive);
  }

  onSubmit() {
    this.router.navigate(['/miscellaneous/search']);

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/header.component.ts